import { useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import AuthService from '../services/auth.service'
import { setAuthenticationData, authInit } from '../store/auth.reducer'

export default function useAuth(service: AuthService) {
  const dispatch = useDispatch()

  const setAuthentication = useCallback((e) => dispatch(setAuthenticationData(e)), [dispatch])

  useEffect(() => {
    dispatch(authInit())
    const subs = service.authenticationDataSubs().subscribe(setAuthentication)
    service.sendRequestAuthenticationData()
    return () => {
      subs.unsubscribe()
    }
  }, [dispatch, service, setAuthentication])
}
